import { createClient } from '@supabase/supabase-js'

// Get environment variables
const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || ''

// Validate environment variables are present
if (!supabaseUrl || !supabaseAnonKey) {
    console.error('❌ Missing Supabase environment variables! Please check your .env.local file.')
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface AuditRequest {
    id?: number;
    website_url: string;
    primary_goal: string;
    name: string;
    email: string;
    created_at?: string;
}

export interface ZoomCallRequest {
    id?: number;
    service: string;
    project_details?: string;
    name: string;
    email: string;
    phone: string;
    created_at?: string;
}
